import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchVendorMasterList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/vendorMaster/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setVendorMasterList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadVendorStatement = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/vendorMaster/statement.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setVendorMasterStatementList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchVendorMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/vendorMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setVendorMasterData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchDocumentList', {vendor_id: payload.id, copy: payload.copy})     
            
            dispatch('loadProvinceList', res.data.response.country_id)
            dispatch('loadCityList', res.data.response.province_id)
            commit('resetInventoryInvoiceOutstandingList')

            dispatch('fetchInventoryOrderList', {store_list: payload.store_list, vendor_id: payload.id})
            dispatch('fetchInventoryInvoiceList', {store_list: payload.store_list, vendor_id: payload.id})
            dispatch('fetchVendorPaymentList', {store_list: payload.store_list, vendor_id: payload.id})

            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetVendorMasterData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitVendorMasterData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/vendorMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
                
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteVendorMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/vendorMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchVendorMasterList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorMaster/actions.js